export default "__VITE_ASSET__DB30DZ5D__"